export const PATH = {
  home: '/',

}



// WEBPACK FOOTER //
// ./src/const/path.js